import { Toast } from 'vant';
import GridPolice from '@/components/police_service/police_service';
import EduService from '@/components/provincial_level/edu_service/edu_service';
import QueryService from '@/components/provincial_level/query_service/query_service';
import GridCommon from '@/components/provincial_level/common_service/common_service';
import GridFinance from '@/components/finance_service/finance_service';
import NoticeDialog from '@/components/notice_dialog/notice_dialog';
import MyCsService from '@/components/provincial_level/my_cs_service/my_cs_service';
import HumanService from '@/components/provincial_level/human_service/human_service';

export default {
    name: 'index',
    data () {
        return {
          adressData:[],
          isShowNotice: false
        }
    },
    methods : {
        closeNotice() {
          this.isShowNotice = false;
        },
        getImageUrl: function(url) {
          return './96111/' + url;
        },
        miniProgrem() {
            wechat.onConfig({
                apiList: ['getLocation'],
                openTagList: ['wx-open-launch-weapp'],
                success: function() {

                }
            });
        }
    },
    mounted : function() {
      let vm = this;
      this.miniProgrem()
      $.get('./96111/banner/list', function(result) {
          if(result.success) {
              vm.adressData = result.data;
          } else {
              Toast(result.message);
          }
      });
      // let temp = window.localStorage.getItem("showLog");
      // if(temp) {
      //     return;
      // }
      // this.isShowNotice = true;
      // window.localStorage.setItem("showLog", true);
    },
    components: {
        'EduService': EduService,
        'GridPolice': GridPolice,
        'GridCommon':GridCommon,
        'GridFinance':GridFinance,
        'NoticeDialog': NoticeDialog,
        'my-cs-service': MyCsService,
        'QueryService': QueryService,
        'HumanService': HumanService
    }
}


// WEBPACK FOOTER //
// ./src/page/index/index.controller.js